module.exports = __webpack_public_path__ + "img/supervisor-intro-seven.b75d7af5.png";